export default __webpack_public_path__ + "f39b77c49c500e7dce2c6b2bffea56a4.png";